import { BodyFour, HeadlineSix, OverlineSix } from '@nucleus/ncu-section-builder';
import { CardItemApi } from '@nucleus/types/web';

export const CardItemDefaults: Partial<CardItemApi> = {
  overline: OverlineSix({ children: '' }),
  headline: HeadlineSix({ children: '' }),
  body: BodyFour({ children: '' }),
  actions: [],
  mediaItems: [],
};
